export class FormDataObject {
    name = "";
    phone="";
    email="";
    association="";
    occupation="";
    description="";
    static errorMessage = "";

    constructor(name, phone, email, association, occupation, description){
        if(this.validate(name) && this.validatePhone(phone)
        && this.validateEmail(email) && this.validate(association)
        && this.validate(occupation) && this.validate(description)){
            this.name = name;
            this.phone = phone;
            this.email = email;
            this.association = association;
            this.occupation = occupation;
            this.description = description;
        }
        else
            throw this.errorMessage;
    }

    validate = (value) =>{
        if(value.trim() === ""){
            this.errorMessage = "כל השדות הם חובה";
            return false;
        }
        return true;
    }
    validatePhone = (value) =>{
        if ((isNaN(parseFloat(value)) && !isFinite(value)) || value.length < 7 || value.length > 15) {
            this.errorMessage = "טלפון לא תקין";
            return false;
        }
        return true;
    }
    validateEmail = (value) =>{
        if (value.indexOf("@") < 0 || value.indexOf(".") < 0) {
            this.errorMessage = "דוא\"ל לא תקין";
            return false;
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/Components/Main/FormDataObject.js